import Events from '@utilities/events';

const JS_HOOK_PAGINATION_BUTTON = '[js-hook-pagination-button]';

class Pagination {
  constructor(element) {
    this.element = element;
    this.paginationButtons = [...this.element.querySelectorAll(JS_HOOK_PAGINATION_BUTTON)];

    this.bindEvents();
  }

  /**
   * Getting new grid html through Ajax call
   * @param event
   */
  static getPageData(event) {
    event.preventDefault();

    const button = event.currentTarget;

    const url = button.href;

    if (!url) return;

    Pagination.refinementsUpdate(url);
    Pagination.updateHistory(url);
  }


  /**
   * Replacing current history to the current visible grid
   * @param {url} url
   */
  static updateHistory(url) {
    Events.$trigger('history::push', {
      data: { url, state: { url } },
    });
  }


  /**
   * Replacing current history to the current visible grid
   * @param {url} url
   */
  static refinementsUpdate(url) {
    Events.$trigger('history::refinements-update', {
      data: {
        url,
        state: {
          url,
          scrollTop: true,
        }
      },
    })
  }

  bindEvents() {
    if (this.paginationButtons) {
      this.paginationButtons.forEach((button) =>
        button.addEventListener('click', (event) => Pagination.getPageData(event)),
      )
    }

    window.addEventListener('popstate', () => {
      document.documentElement.scrollTop = 0;
      window.location.reload();
    });
  }
}

export default Pagination;
